import { render } from "./InventoryMain.vue?vue&type=template&id=9f191bde&scoped=true"
import script from "./InventoryMain.vue?vue&type=script&lang=js"
export * from "./InventoryMain.vue?vue&type=script&lang=js"

import "./InventoryMain.vue?vue&type=style&index=0&id=9f191bde&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f191bde"]])

export default __exports__